/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect } from 'react';
import { Context as MediaContext } from '../context/MediaContext';
import {
  IMAGE_BASE_URL,
  POSTER_SIZE,
  IMDB_URL,
  YOUTUBE_SEARCH_URL,
} from '../config';

const MediaCard = ({ type, media }) => {
  const { state, fetchTvShowDetails, fetchTvShowLink, fetchMovieDetails } =
    useContext(MediaContext);

  useEffect(() => {
    if (type === 'tv') fetchTvShowDetails(media.id);
  }, []);

  return (
    <div className="card">
      {media.imdb_id ? (
        <a
          href={`${IMDB_URL}${media.imdb_id}/`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="image"
            src={`${IMAGE_BASE_URL}${POSTER_SIZE}${media.poster_path}`}
            alt={type === 'tv' ? media.name : media.title}
          />
        </a>
      ) : (
        <img
          className="image"
          src={`${IMAGE_BASE_URL}${POSTER_SIZE}${media.poster_path}`}
          alt={type === 'tv' ? media.name : media.title}
          onClick={() =>
            type === 'tv'
              ? fetchTvShowLink(media.id)
              : fetchMovieDetails(media.id)
          }
          role="button"
          tabIndex="0"
        />
      )}

      <div className="card-details">
        <p className="rating">
          {media.vote_average}
          <sub>/10</sub>
        </p>

        <p className="name">
          {media.imdb_id ? (
            <a
              href={`${IMDB_URL}${media.imdb_id}/`}
              target="_blank"
              rel="noreferrer"
            >
              {type === 'tv' ? media.name : media.title}
            </a>
          ) : (
            <span
              role="button"
              tabIndex="0"
              onClick={() =>
                type === 'tv'
                  ? fetchTvShowLink(media.id)
                  : fetchMovieDetails(media.id)
              }
            >
              {type === 'tv' ? media.name : media.title}
            </span>
          )}
          &nbsp;&nbsp;&nbsp;
          <sub>
            {media.genres
              ? media.genres.map((genre) => `${genre.name} `)
              : media.genre_ids.map((id) =>
                  type === 'tv'
                    ? `${state.tvShowGenres[id]} `
                    : `${state.movieGenres[id]} `
                )}
          </sub>
        </p>

        {/* 
          A tv show has only one home page, but can have multiple networks
          so we check if a substring of the network name is in the homepage
          url. If it is, we return an anchor tag, else we just return the 
          network name.
        */}

        {media.networks && (
          <p className="networks">
            Playing On:{' '}
            {media.networks.map((network) => {
              if (
                media.homepage.includes(
                  network.name.substring(0, 5).toLowerCase()
                )
              ) {
                return (
                  <a
                    href={media.homepage}
                    target="_blank"
                    rel="noreferrer"
                    key={network.id}
                  >
                    {network.name}
                  </a>
                );
              }
              return `${network.name} `;
            })}
          </p>
        )}

        {media && (
          <a
            className="trailer-link"
            href={`${YOUTUBE_SEARCH_URL}${
              type === 'tv'
                ? media.name.replace(' ', '+')
                : media.title.replace(' ', '+')
            }+1080p+trailer`}
            target="_blank"
            rel="noreferrer"
          >
            <p>Watch Trailer</p>
          </a>
        )}
      </div>
    </div>
  );
};

export default MediaCard;
